import Config from '@annunciate/core/dist/utils/config';
import { MANAGE_PURCHASES_GET } from '../queries';
import { requestWithAuth } from '../request';
export async function getManagePurchasesData() {
    const result = await requestWithAuth({
        endpoint: `${Config.ENTITLEMENTS_HOST}/graphql`,
        query: MANAGE_PURCHASES_GET,
    });
    return result?.managePurchases || {
        url: undefined,
        channel: undefined,
    };
}
//# sourceMappingURL=getManagePurchasesData.js.map